export default "__VITE_ASSET__BeFuGaol__"